import React from "react";

export const CheckProgram: React.FC<{
    name: string;
    className?: string;
}> = ({ name, className }) => {
    return (
            <div className={'flex items-center mx-2' + className}>
                <img 
                src="/img/lms/check.png" 
                alt="Checklist" 
                className="w-4 h-4 mr-2" />
                <span className="text-xs md:text-sm font-body font-semibold leading-5 text-secondary-100">{name}</span>
            </div>

    )
}
